import { render, staticRenderFns } from "./stagework.vue?vue&type=template&id=0f9a3e56"
import script from "./stagework.vue?vue&type=script&lang=js"
export * from "./stagework.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports